// src/components/configuracion/ConfiguracionPage.jsx (Refactorizado)
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Container,
  Tabs,
  Tab,
  Typography,
  Alert
} from '@mui/material';

// Componentes compartidos refactorizados
import { CardContainer, TabPanel } from '../shared';
import CatalogosTab from './CatalogosTab';
import AutomatizacionTab from './AutomatizacionTab';

/**
 * Página de configuración del sistema
 * Permite acceder a diferentes secciones de configuración a través de pestañas
 */
const ConfiguracionPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const { empresaActiva } = useSelector(state => state.empresa);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const subheader = empresaActiva
    ? `Configuración para ${empresaActiva.nombre_corto || empresaActiva.razon_social} (${empresaActiva.rut}-${empresaActiva.dv})`
    : undefined;

  return (
    <Container maxWidth="lg">
      {!empresaActiva && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Debe seleccionar una empresa para acceder a la configuración.
        </Alert>
      )}

      <CardContainer
        title="Configuración del Sistema"
        subheader={subheader}
        cardProps={{
          sx: { width: '100%', mb: 3 },
          elevation: 1
        }}
        headerProps={{
          sx: { pb: 0 },
          component: 'div'
        }}
        contentProps={{
          sx: { p: 0 }
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Catálogos Contables" id="config-tab-0" aria-controls="config-tabpanel-0" />
          <Tab label="Automatización RCV" id="config-tab-1" aria-controls="config-tabpanel-1" />
          <Tab label="Parámetros Generales" id="config-tab-2" aria-controls="config-tabpanel-2" disabled />
          <Tab label="Usuarios y Permisos" id="config-tab-3" aria-controls="config-tabpanel-3" disabled />
        </Tabs>
        
        <TabPanel 
          value={tabValue} 
          index={0}
          id="config-tabpanel-0"
          aria-labelledby="config-tab-0"
        >
          <CatalogosTab />
        </TabPanel>
        
        <TabPanel
          value={tabValue}
          index={1}
          id="config-tabpanel-1"
          aria-labelledby="config-tab-1"
        >
          <AutomatizacionTab />
        </TabPanel>

        <TabPanel
          value={tabValue}
          index={2}
          id="config-tabpanel-2"
          aria-labelledby="config-tab-2"
        >
          <Typography variant="body1" color="text.secondary">
            Configuración de parámetros generales (próximamente)
          </Typography>
        </TabPanel>

        <TabPanel
          value={tabValue}
          index={3}
          id="config-tabpanel-3"
          aria-labelledby="config-tab-3"
        >
          <Typography variant="body1" color="text.secondary">
            Gestión de usuarios y permisos (próximamente)
          </Typography>
        </TabPanel>
      </CardContainer>
    </Container>
  );
};

export default ConfiguracionPage;